import React, { useState, useEffect, useCallback, useMemo } from 'react';

import { useLocation } from '@reach/router';

import { navigate, PageRenderer, Link } from 'gatsby';

import Modal from 'react-modal';
import { IoMdClose } from 'react-icons/io';

import ToolDetail from '../components/tool/ToolDetail';

Modal.setAppElement(`#___gatsby`);

const TIMEOUT = 100;
const building = typeof window === 'undefined';

const ModalTemplate = ({ pageContext: { node, targetPath, modalType } }) => {
  const { pathname } = useLocation();

  const cutPath = pathname.slice(0, pathname.lastIndexOf('/')) || '/';

  const path = targetPath || '/';

  const [modalOpen, setModalOpen] = useState(true);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setTimeout(() => navigate(path), TIMEOUT);
  }, [path]);

  const handleClose = useCallback(
    e => {
      e.preventDefault();
      closeModal();
    },
    [closeModal],
  );

  const [pageData, setPageData] = useState(!building && window.pageData);

  useEffect(() => {
    window.setPageData = () => {
      setPageData(window.pageData);
    };
  }, []);

  const pageDataString = useMemo(() => {
    return JSON.stringify(pageData);
  }, [pageData]);

  useEffect(() => {
    if (typeof pageData === 'object') {
      setPageData({ ...pageData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageDataString]);

  return (
    <div>
      {!building && pageData && (
        <PageRenderer
          key={path}
          location={{ pathname: path }}
          pageResources={pageData[cutPath]}
          path={path}
        />
      )}
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        contextLabel="Modal"
        closeTimeoutMS={TIMEOUT}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <Link to={path} onClick={e => handleClose(e)} className="react-modal-close">
          <IoMdClose />
        </Link>
        {modalType === 'tool' && <ToolDetail node={node} />}
      </Modal>
    </div>
  );
};

export default ModalTemplate;
